import React,{ Component, Fragment} from "react";
import {
    ExportOutlined,
    HomeFilled,
    UserOutlined,
    SmileTwoTone,
    SwapOutlined,
    SettingOutlined,
    EditOutlined, RightSquareOutlined
} from "@ant-design/icons";
import {Button, message, Popover, Card, Avatar, Modal, Input, Form, Tooltip, Select} from "antd";
import {fetchPost} from "../static/util/fetch";
import {isActive} from "../static/util/OvertimeLogin";
const { Meta } = Card;
const Option = Select.Option;
class Header extends Component{
    constructor(props) {
        super(props);
        this.state={
            userId:localStorage.getItem("userId"),
            switch_visible:false,
            username:'',
            phone: '',
            password: '',
            systemName:'',
            usernameSet:'',
            phoneSet:'',
            areaSet:'',
            codeSet:'',
            newPasswordSet:'',
            oldPasswordSet:'',
            newPhoneSet:'',
            usernameSetStatus:'',
            areaSetStatus:'',
            setting_visible:false,
            areaList:[],
            password_visible:false,
            confirmPassword:'',
            phoneSetStatus:false,
            checkCode:'',
            getCodeStatus:true,
            count:60,
        }
        this.hideModal = this.hideModal.bind(this);
        this.logout = this.logout.bind(this);
        this.switch = this.switch.bind(this);
        this.login = this.login.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
    }
    componentDidMount() {
        fetchPost(global.constants.getSysConfig,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            systemName:res.data.systemName,
                        }))
                        if(res.data.systemColor === 1){
                            require([`../style.css`], function(list){});
                        }
                        if(res.data.systemColor === 2){
                            require([`../styleOrange.css`], function(list){});
                        }
                        if(res.data.systemColor === 3){
                            require([`../styleGray.css`], function(list){});
                        }
                    }
                }
            )
        fetchPost(global.constants.getUserMessage,{})
            .then(
                res =>{
                    if(res.code === 200){
                        this.setState(()=>({
                            username:res.data.username,
                        }))
                    }
                }
            )
        fetchPost(global.constants.getAllUserAreaList,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            areaList:res.data
                        }))
                    }
                }
            )
    }
    logout(){
        fetchPost(global.constants.logout,{})
            .then(
                res =>{
                    if(res.code === 200){
                        let history = this.props.history;
                        history.replace('/');
                        localStorage.removeItem("userId")
                        localStorage.removeItem("username")
                        localStorage.removeItem("companyName")
                        localStorage.removeItem("companyId")
                        localStorage.removeItem("area")
                        localStorage.removeItem("identity")
                        message.success("用户已安全退出系统！").then()
                    }
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            switch_visible:false,
            setting_visible:false,
            areaSetStatus:false,
            usernameSetStatus:false,
        }))
    }
    switch(){
        this.setState(()=>({
            switch_visible:true,
        }))
    }
    login(){
        fetchPost(global.constants.logout,{})
            .then(
                res =>{
                    if(res.code === 200){
                        localStorage.removeItem("userId")
                        localStorage.removeItem("username")
                        localStorage.removeItem("companyName")
                        localStorage.removeItem("companyId")
                        localStorage.removeItem("area")
                        localStorage.removeItem("identity")
                    }
                }
            )
        let params = {
            phone: this.state.phone,
            password: this.state.password
        }
        const regPhone =/^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9])).{8,}$/
        const newResPhone = regPhone.test(this.state.phone)
        if(this.state.phone === ''||this.state.password === ''){
            message.info("请填写登录信息").then()
        }else{
            if( newResPhone === false){
                message.info('请检查该手机号是否真实！').then()
            }else{
                fetchPost(global.constants.login, params)
                    .then(
                        res => {
                            res.msg = '';
                            if(res.code === 201){
                                localStorage.setItem("userId",res.data.id)
                                localStorage.setItem("username",res.data.username)
                                let history = this.props.history;
                                history.push('/superMaster')
                                window.location.reload()
                                message.success('登录成功！').then()
                                this.setState(()=>({
                                    switch_visible:false,
                                }))
                            }
                            if(res.code === 202){
                                localStorage.setItem("userId",res.data.id)
                                localStorage.setItem("username",res.data.username)
                                localStorage.setItem("identity",res.data.identity)
                                let history = this.props.history;
                                history.push('/companylistnavigation')
                                window.location.reload()
                                message.success('登录成功！').then()
                                this.setState(()=>({
                                    switch_visible:false,
                                }))
                            }
                            if(res.code === 200){
                                localStorage.setItem("userId",res.data.id)
                                localStorage.setItem("username",res.data.username)
                                localStorage.setItem("identity",res.data.identity)
                                this.setState(()=>({
                                    id:res.data.id,
                                }))
                                let history = this.props.history;
                                history.push("/companylistnavigation")
                                window.location.reload()
                                message.success('登录成功！').then()
                                this.setState(()=>({
                                    switch_visible:false,
                                }))
                            }
                            if(res.code === -1){
                                this.setState(()=>({
                                        phone:'',
                                        password:'',
                                        count:this.state.count + 1,
                                        inputCode:'',
                                    })
                                )
                                this.randomCode();
                                message.error("请检查输入的密码!").then()
                            }
                            if(res.code === -2){
                                this.setState(()=>({
                                        password:'',
                                        count:this.state.count + 1,
                                        inputCode:'',
                                    })
                                )
                                this.randomCode();
                                message.error("登录失败，请输入密码！").then()
                            }
                            if(res.code === -3){
                                this.setState(()=>({
                                        phone:'',
                                        password:'',
                                        count:this.state.count + 1,
                                        inputCode:'',
                                    })
                                )
                                this.randomCode();
                                message.error("登录失败，帐号不存在！").then()
                            }
                            if(res.code === -4){
                                this.setState(()=>({
                                        password:'',
                                        count:this.state.count + 1,
                                        inputCode:'',
                                    })
                                )
                                this.randomCode();
                                message.error("登录失败，密码错误！").then()
                            }
                            if(res.code === 500){
                                this.setState(()=>({
                                        phone:'',
                                        password:''
                                    })
                                )
                                message.error("异常！").then()
                            }
                        }
                    )
                }
        }
    }
    handleUpdate(){
        this.setState(()=>({
            usernameSetStatus:false,
            areaSetStatus:false,
            phoneSetStatus:false,
        }))
        fetchPost(global.constants.getUserMessage,{})
            .then(
                res =>{
                    if(res.code === 200){
                        this.setState(()=>({
                            usernameSet:res.data.username,
                            areaSet:res.data.area,
                            phoneSet:res.data.phone,
                            codeSet:res.data.code,
                            setting_visible:true,
                        }))
                    }
                }
            )
    }
    handleUsernameSet(){
        this.setState(()=>({
            usernameSetStatus:true
        }))
    }
    usernameSetUpdate(){
        let params={
            id:this.state.userId,
            username:this.state.usernameSet,
            area: this.state.areaSet
        }
        fetchPost(global.constants.updateUser,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success('修改成功').then()
                        fetchPost(global.constants.getUserMessage,{})
                            .then(
                                res =>{
                                    if(res.code === 200){
                                        this.setState(()=>({
                                            usernameSet:res.data.username,
                                            username:res.data.username,
                                            usernameSetStatus:false,
                                        }))
                                    }
                                }
                            )
                    }
                }
            )
    }
    handleAreaSet(){
        this.setState(()=>({
            areaSetStatus:true
        }))
    }
    areaSetUpdate(){
        let params={
            id:this.state.userId,
            username:this.state.usernameSet,
            area: this.state.areaSet
        }
        fetchPost(global.constants.updateUser,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success('修改成功').then()
                        fetchPost(global.constants.getUserMessage,{})
                            .then(
                                res =>{
                                    if(res.code === 200){
                                        this.setState(()=>({
                                            areaSet:res.data.area,
                                            areaSetStatus:false,
                                        }))
                                    }
                                }
                            )
                    }
                }
            )
    }
    hideTwoModal(){
        this.setState(()=>({
            password_visible:false,
            usernameSetStatus:false,
            areaSetStatus:false,
            phoneSetStatus:false,
        }))
    }
    handlePasswordSet(){
        this.setState(()=>({
            password_visible:true,
            oldPasswordSet:'',
            newPasswordSet:'',
        }))
    }
    passwordUpdate(){
        const regPassword =/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,}$/;
        const newResPassword = regPassword.test(this.state.newPasswordSet);
        if(this.state.oldPasswordSet===''||this.state.newPasswordSet===''||this.state.confirmPassword===''){
            message.error("请完善信息！").then()
        }
        else {
            if (this.state.newPasswordSet !== this.state.confirmPassword) {
                message.error("两次输入的密码不一致！").then()
            }else{
                if(newResPassword === false){
                    message.error("请注意密码格式！").then()
                }else{
                    let params={
                        newPassword:this.state.newPasswordSet,
                        oldPassword: this.state.oldPasswordSet,
                    }
                    fetchPost(global.constants.updatePassword,params)
                        .then(
                            res=>{
                                if(res.code === 200){
                                    message.success('密码修改成功').then()
                                    this.setState(()=>({
                                        password_visible:false
                                    }))
                                }else{
                                    message.info('原密码错误').then()
                                }
                            }
                        )
                }
            }
        }
    }
    handlePhoneSet(){
        this.setState(()=>({
            phoneSetStatus:true,
            newPhoneSet:'',
        }))
    }
    getCode(){
        let params={
            phone:this.state.newPhoneSet,
        }
        if(params.phone===''){
            message.info("请输入手机号").then()
        }else{
            fetchPost(global.constants.findPhone,params)
                .then(
                    res => {
                        if (res.code === 200) {
                            this.setState(()=>({
                                getCodeStatus:false,
                            }))
                            this.countDown()
                            message.success("验证码发送成功，5分钟内有效，请注意查收！").then()
                        }
                        if (res.code === -1){
                            message.info("该手机号不存在！").then()
                        }
                        if (res.code === -2) {
                            message.info("一小时内已发送五条验证短信，请稍后再试！").then()
                        }
                    }
                )
        }
    }
    countDown() {
        const { count } = this.state
        if (count === 1) {//当为0的时候，liked设置为true，button按钮显示内容为 获取验证码
            this.setState({
                count: 60,
                getCodeStatus: true,
            })
        } else {
            this.setState({
                count: count - 1,
                getCodeStatus: false,
            })
            setTimeout(() => this.countDown(), 1000)//每一秒调用一次
        }
    }
    phoneSetUpdate(){
        if(this.state.newPhoneSet === ''||this.state.checkCode === ''){
            message.info('请完善信息!').then()
        }else{
            let params={
                newPhone:this.state.newPhoneSet,
                code:this.state.checkCode,
            }
            fetchPost(global.constants.updatePhone,params)
                .then(
                    res => {
                        if (res.code === 200) {
                            message.success(res.msg).then()
                            this.setState(()=>({
                                getCodeStatus:false,
                                phoneSetStatus:false,
                            }))
                            fetchPost(global.constants.getUserMessage,{})
                                .then(
                                    res =>{
                                        if(res.code === 200){
                                            this.setState(()=>({
                                                phoneSet:res.data.phone,
                                            }))
                                        }
                                    }
                                )
                        }
                        if (res.code === -1){
                            message.info(res.msg).then()
                        }
                    }
                )
        }

    }
    render(){
        const content = (
                <Card
                    hoverable
                    // cover={
                    //     <img alt={'退出界面'} src={header} style={{width:'230px'}}/>
                    // }
                    style={{ width: 200}}
                    actions={[
                        <Tooltip title="退出">
                            <ExportOutlined key="logout" onClick={this.logout} style={{fontSize:'20px'}}/>
                        </Tooltip>,
                        <Tooltip title="切换账户">
                            <SwapOutlined key="switch" onClick={this.switch} style={{fontSize:'20px'}}/>
                        </Tooltip>,
                        <Tooltip title="修改个人信息">
                            <SettingOutlined key="setting" onClick={this.handleUpdate} style={{fontSize:'20px'}}/>
                        </Tooltip>
                    ]}
                >
                    <Meta
                        avatar={<Avatar src={<SmileTwoTone style={{fontSize:'30px'}}/>}  />}
                        title={this.state.username}
                    />
                </Card>
            )
        const history = this.props.history
        isActive(history)
        return(
        <Fragment>
            <div className="site-page-header">
                <div className={"site-page-header-leftArea"}>
                    <HomeFilled className="header-icon-style" />
                    <span className="header-word-style">{this.state.systemName}</span>
                </div>
                <div className={"site-page-header-rightArea"}>
                    <div className="header-welcome">{this.state.username}，欢迎您！</div>
                    <Popover content={content}>
                        <Button icon={<UserOutlined />}  className="header-user"  size="middle" shape="circle"/>
                    </Popover>
                </div>
            </div>
            <Modal
                visible={this.state.switch_visible}
                title={'切换账户'}
                onOk={this.login}
                onCancel={this.hideModal}
                destroyOnClose
                footer={[
                    <Button key="back" onClick={this.hideModal}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary"  onClick={this.login}>
                        切换账户登录
                    </Button>,
                ]}
            >
                <Form>
                    <Form.Item label="账号" name="phone" rules={[{ required: true, message: '请输入账号!' }]}>
                        <Input
                            placeholder="请输入账号（手机号）"
                            type="text"
                            value={this.state.phone}
                            onChange={this.handleInputTelNumber.bind(this)}/>
                    </Form.Item>
                    <Form.Item label="密码" name="password" rules={[{ required: true, message: '请输入密码!' }]}>
                        <Input
                            placeholder="请输入密码"
                            type="password"
                            value={this.state.password}
                            onChange={this.handleInputPassword.bind(this)}/>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                visible={this.state.setting_visible}
                title={'个人信息'}
                onCancel={this.hideModal}
                destroyOnClose
                footer={[
                    <Button key="back" onClick={this.hideModal}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary"  onClick={this.hideModal}>
                        完成
                    </Button>,
                ]}
            >
                <Form>
                    <Form.Item label="用户名" name="usernameSet">
                        {
                            this.state.usernameSetStatus === true?
                                <div>
                                    <Input
                                        style={{width:'200px'}}
                                        defaultValue={this.state.usernameSet}
                                        onChange={(e) => this.usernameSetChange(e.target.value)}
                                    />
                                    <Button
                                        style={{marginLeft:'10px'}}
                                        icon={<EditOutlined/>}
                                        onClick={this.hideTwoModal.bind(this)}>取消</Button>
                                    <Button
                                        type="primary"
                                        style={{marginLeft:'10px'}}
                                        icon={<RightSquareOutlined/>}
                                        onClick={this.usernameSetUpdate.bind(this)}>提交</Button>
                                </div>
                                :
                                <div>
                                    {this.state.usernameSet}
                                    <Button
                                        style={{marginLeft:'10px'}}
                                        icon={<EditOutlined/>}
                                        onClick={this.handleUsernameSet.bind(this)}>编辑</Button>
                                </div>
                        }
                    </Form.Item>
                    <Form.Item label="地区" name="areaSet">
                        {
                            this.state.areaSetStatus === true?
                                <div>
                                    <Select showSearch
                                            allowClear
                                            defaultValue={this.state.areaSet}
                                            style={{ width: 200 }}
                                            placeholder="请选择地区"
                                            optionFilterProp="children"
                                            notFoundContent="无法找到"
                                            searchPlaceholder="输入关键词"
                                            onChange={this.areaSetChange.bind(this)}
                                    >
                                        {this.state.areaList.map(item => (
                                            <Option key={item} value={item}>
                                                {item}
                                            </Option>
                                        ))}
                                    </Select>
                                    <Button
                                        style={{marginLeft:'10px'}}
                                        icon={<EditOutlined/>}
                                        onClick={this.hideTwoModal.bind(this)}>取消</Button>
                                    <Button
                                        type="primary"
                                        style={{marginLeft:'10px'}}
                                        icon={<RightSquareOutlined/>}
                                        onClick={this.areaSetUpdate.bind(this)}>提交</Button>
                                </div>
                                :
                                <div>
                                    {this.state.areaSet}
                                    <Button
                                        style={{marginLeft:'10px'}}
                                        icon={<EditOutlined/>}
                                        onClick={this.handleAreaSet.bind(this)}>编辑</Button>
                                </div>
                        }
                    </Form.Item>
                    <Form.Item label="密码" name="oldPasswordSet">
                        <Button
                            style={{marginLeft:'10px'}}
                            icon={<EditOutlined/>}
                            onClick={this.handlePasswordSet.bind(this)}>修改密码</Button>
                    </Form.Item>
                    <Form.Item label="手机号" name="phoneSet">
                        {
                            this.state.phoneSetStatus === true?
                                <Form>
                                    <Form.Item label="新手机号" name="newPhoneSet" rules={[{required: true, message: '请输入新手机号!',}]}>
                                        <Input
                                            style={{width:'200px'}}
                                            onChange={(e) => this.newPhoneSetChange(e.target.value)}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="checkNumber"
                                        label="验证码"
                                        rules={[{required: true, message: '请输入验证码!',}]}
                                        hasFeedback
                                    >
                                        <Input style={{width:'200px'}} onChange={this.handleInputCheckCode.bind(this)}/>
                                        {
                                            this.state.getCodeStatus === true?
                                                <Button
                                                    className="checkNumberButton"
                                                    type="primary"
                                                    onClick={this.getCode.bind(this)}
                                                >发送验证码</Button>:
                                                <Button
                                                    className="checkNumberButton"
                                                    disabled
                                                    type="primary"
                                                >{this.state.count}s后重新发送</Button>
                                        }
                                    </Form.Item>
                                    <Button
                                        style={{marginLeft:'10px'}}
                                        onClick={this.hideTwoModal.bind(this)}>取消</Button>
                                    <Button
                                        type={'primary'}
                                        style={{marginLeft:'10px'}}
                                        onClick={this.phoneSetUpdate.bind(this)}>提交</Button>
                                </Form>
                                :<div>
                                    {this.state.phoneSet}
                                    <Button
                                        style={{marginLeft:'10px'}}
                                        icon={<EditOutlined/>}
                                        onClick={this.handlePhoneSet.bind(this)}>修改手机号</Button>
                                </div>
                        }
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                visible={this.state.password_visible}
                title={'修改密码'}
                onCancel={this.hideTwoModal.bind(this)}
                destroyOnClose
                footer={[
                    <Button key="back" onClick={this.hideTwoModal.bind(this)}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary"  onClick={this.passwordUpdate.bind(this)}>
                        提交
                    </Button>,
                ]}
            >
                <Form>
                    <Form.Item
                        name="oldPasswordSet"
                        label="原密码"
                        rules={[
                            {
                                required: true,
                                message: '请输入原密码!',
                            },
                        ]}
                    >
                        <Input.Password  onChange={this.oldPasswordSetChange.bind(this)}/>
                    </Form.Item>
                    <Form.Item
                        name="newPasswordSet"
                        label="新密码"
                        rules={[
                            {
                                required: true,
                                message: '请输入8个及以上字母、数字、特殊符号中至少两种字符组成，区分大小写作为新密码!',
                            },
                        ]}
                        hasFeedback
                    >
                        <Input.Password  placeholder={'8个及以上字母、数字、特殊符号中至少两种字符组成，区分大小写'}
                                         onChange={this.newPasswordSetChange.bind(this)}/>
                    </Form.Item>
                    <Form.Item
                        name="confirm"
                        label="确认密码"
                        dependencies={['newPasswordSet']}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: '请确认你的密码!',
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('newPasswordSet') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('两次输入的密码不一致!'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password onChange={this.handleConfirmPassword.bind(this)}/>
                    </Form.Item>
                </Form>
            </Modal>
        </Fragment>

        )
    }
    newPhoneSetChange(e){
        this.setState(()=>({
            newPhoneSet:e
        }));
    }
    handleInputCheckCode = (e) =>{
        const value  = e.target.value;
        this.setState(()=>({
            checkCode:value
        }));
    }
    oldPasswordSetChange(e){
        const value  = e.target.value;
        this.setState(()=>({
            oldPasswordSet:value
        }));
    }
    newPasswordSetChange(e){
        const value  = e.target.value;
        this.setState(()=>({
            newPasswordSet:value
        }));
    }
    handleConfirmPassword(e){
        const value  = e.target.value;
        this.setState(()=>({
            confirmPassword:value
        }));
    }
    usernameSetChange(e){
        this.setState(()=>({
            usernameSet:e
        }));
    }
    areaSetChange(e){
        this.setState(()=>({
            areaSet:e
        }));
    }
    handleInputTelNumber(e){
        const value  = e.target.value;
        this.setState(()=>({
            phone:value
        }));
        const regPhone =/^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9])).{8,}$/
        const newResPhone = regPhone.test(value)
        if(value.length === 11 && newResPhone === false){
            message.info('请检查手机号是否真实！').then()
        }
    }
    handleInputPassword(e){
        const value  = e.target.value;   //value需要定义在外层
        this.setState(()=>({
            password:value
        }));
    }
}
export default Header;